<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {

  },
  methods:{
    //判断是否为移动端
    _ismobile(){
      let flag = navigator.userAgent.match(
          /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
      );
      return flag;
    }
  }
}
</script>
<style lang="less">
 html,body,h3{
   margin: 0;
   padding: 0;
 }
</style>

